export default __webpack_public_path__ + "static/media/f2.8bf93dc8.jpg";